module.exports = __webpack_public_path__ + "static/media/chlodzenie.97865baa.svg";